import { useContext, useState } from "react"
import { Button, IconGoogle } from "../../../components/atoms"
import { InputGroup } from "../../../components/molecules"
import { AuthContext } from "../../../contexts/Auth/AuthContext"
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext"
import { api } from "../../../helpers"
import { useApi } from "../../../hooks/useApi"

const theObjectsAreTheSame = (objA: Object, objB: Object) => {
  return JSON.stringify(objA) === JSON.stringify(objB)
}

export function CancelarReserva() {
  const { applicationData } = useContext(AuthContext)
  const {
    setType,
    setShow,
    setText: setTextAlert
  } = useContext(NotificationContext)

  const [mensagem, setMensagem] = useState("")
  const { getReserva } = useApi()
  const [reserva, setReserva] = useState<Reserva>({
    codigo: null,
    cliente: "",
    adultos: 0,
    criancas: 0,
    embarque: new Date(),
    preco: 0,
    origem: "",
    destino: "",
    rota: "",
    agerba: 0,
    taxa_Embarque: 0,
    valor_Total: 0,
    data_reserva: new Date()
  })

  function CompMensagem() {
    if (reserva.cliente !== "") {
      return (
        <div>
          <p>Reserva: {reserva.codigo}</p>
          <p>Cliente: {reserva.cliente}</p>
          <p>Embarque: {String(reserva.embarque)}</p>
          <p>Origem: {reserva.origem}</p>
          <p>Destino: {reserva.destino}</p>
          <p>Data da Reserva: {String(reserva.data_reserva)}</p>
        </div>
      )
    } else {
      return (
        <div>
          <p> " "</p>
        </div>
      )
    }
  }

  const consultar = async () => {
    if (reserva.codigo === null || reserva.codigo <= 0) {
      setType("danger")
      setTextAlert("Preenchimento da reserva é obrigatorio")
      setShow(true)
    } else {
      const reservaInfo = await getReserva(String(reserva.codigo!))
      if (reservaInfo && !theObjectsAreTheSame(reserva, reservaInfo)) {
        setReserva((current: any) => ({ ...current, ...reservaInfo }))
      }
    }
  }
  const baixar = async () => {
    if (reserva.codigo === null || reserva.codigo <= 0) {
      setType("danger")
      setTextAlert("Preenchimento da reserva é obrigatorio")
      setShow(true)
    } else {
      let codReserva = reserva.codigo
      let usuario = applicationData.funcionario
      const response = await api.post(
        "/api/reserva/cancelarreserva",
        {
          codReserva,
          usuario
        },
        {
          headers: { Authorization: `Bearer ${applicationData.token}` }
        }
      )
      if (response.status === 200) {
        setType("success")
        setTextAlert(response.data)
        setShow(true)
      }
    }
  }

  return (
    <div>
      <h2>Cancelar Reserva</h2>
      <div className="row mt-1">
        <div className="row mt-3">
          <div className="col-sm-12 col-lg-3">
            <InputGroup
              className="col-sm-12 col-lg-2"
              label="Reserva a Ser Cancelada"
              id="duracao"
              type="number"
              //              value={Number(reserva.codigo)}
              autoComplete="off"
              onChange={(e) => {
                setReserva({ ...reserva, codigo: Number(e.target.value) })
              }}
            />
          </div>
          <div className="col-sm-12 col-lg-3">
            <Button
              className="col-sm-12 col-lg-2"
              appearance="primary"
              onClick={() => {
                consultar()
              }}
            >
              Consultar Reserva<IconGoogle>manage_search</IconGoogle>
            </Button>
          </div>
        </div>
        <div className="row mt-3"></div>
        <div className="row mt-3"></div>

        <div className="col-sm-12 col-lg-3">
          <Button
            className="col-sm-12 col-lg-4"
            appearance="success"
            onClick={() => {
              baixar()
            }}
          >
            Cancelar Reserva<IconGoogle>manage_search</IconGoogle>
          </Button>
        </div>
      </div>
      <div>
        <CompMensagem />
      </div>
    </div>
  )
}
